module.exports = __webpack_public_path__ + "media/images/emblems/Rueti_bei_Bueren-coat_of_arms-47d2b1a8c4af098947ac1d93cea76e7f.svg";